'use client';

import { Moon, Sun } from 'lucide-react';

import { useTheme } from '@/contexts/ThemeProvider';

/** Persistent light/dark control shared by the profile sheet and account page. */
export function GuestV2AppearanceSwitch() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="gv-profile-appearance">
      <span className="gv-profile-appearance__icon" aria-hidden="true">
        {theme === 'dark' ? <Moon className="size-5" /> : <Sun className="size-5" />}
      </span>
      <span className="gv-profile-appearance__label">Dark mode</span>
      <button
        type="button"
        role="switch"
        aria-label="Dark mode"
        aria-checked={theme === 'dark'}
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        className="gv-profile-appearance__switch"
      >
        <span className="gv-profile-appearance__thumb" />
      </button>
    </div>
  );
}
